import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { useEffect, useState } from "react";
import { getUserDetails } from "@NA/Services/ADIXtenIntegrationService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { useSelector } from "react-redux";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { getRandomInt } from "@NA/Utils/Utility";

const AdiXtenIntegrationHelper = () => {
    const [uniqueString, setUniqueString] = useState<string>("");

    useEffect(() => {
        //This method is for getting the unique list name
        const generateUniqueString = () => {
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for (let i = 0; i < 5; i++) {
                result += characters.charAt(getRandomInt(0, characters.length - 1));
            }
            const timestamp = new Date().getTime().toString();
            result += timestamp;
            result = result.slice(-5);
            setUniqueString(result);
        };
        generateUniqueString();
    }, []);

    return {
        uniqueListName: "XTEN-ADI-" + uniqueString,
        isUserSignedUp: localStorage.getItem("isXtenUserSignedUp"),
    };
};

//Redirects the user to appropriate page with defined params
export const redirectAction = (id: string, type: string, history: any, redirectUrl: string) => {
    history.push(`${redirectUrl}?id=${id}&type=${type}`);
};

//Logic for checking is user allowed for Xten free trial
export const IsXtenAllowedUser = (allowedUserRole: string): boolean => {
    const [isXtenAllowedUser, setIsAllowedXtenUser] = useState<boolean>(false);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const session = useSelector((state: ApplicationState) => state.context.session);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const isXTenUser = userRoles && userRoles.includes(allowedUserRole?.toString());
    useEffect(() => {
        if (isAuthenticated && isXTenUser) {
            setIsAllowedXtenUser(true);
        }
    }, []);
    return isXtenAllowedUser;
};

//Heart of the ADI-Xten integration custom handler API call for adding  user for free trial, exporting list or redirect to xdraw, xdoc using SSO etc.
export const callToHandler = (
    id: string,
    type: string,
    listName: string,
    toasterContext: any,
    ADIXtenIntegrationHandler: any,
    closeCancel: any,
    loadCurrentCart: any,
    IsTemp?: boolean,
    ListNameInput?: string,
    SetUserAlreadtSignup?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    ADIXtenIntegrationHandler({
        Id: id,
        Type: type,
        WishListName: listName,
        IsTemp: IsTemp,
        ListNameInput: ListNameInput || undefined,
        onSuccess: (response: any) => {
            if (response.status === "Success") {
                if (type === "cart") {
                    loadCurrentCart();
                }
                toasterContext.addToast({
                    body: translate(response.message),
                    messageType: "success",
                });
                if (typeof window !== "undefined") {
                    window.open(`api/v1/singlesignon/signinxten?id=${response?.id}&type=${response?.type}`, "_blank");
                }
            } else {
                if (SetUserAlreadtSignup != undefined) {
                    SetUserAlreadtSignup(false);
                }
                toasterContext.addToast({
                    body: translate(response.message),
                    messageType: "danger",
                });
            }
            closeCancel();
        },
        onError: (errorResponse: any) => {
            // Handle error response
            console.error("Error Response", errorResponse);
            toasterContext.addToast({
                body: translate("Error Occured, Please try after some time"),
                //body: translate(errorResponse.message),
                messageType: "danger",
            });
            closeCancel();
        },
    });
};

export default AdiXtenIntegrationHelper;
